import { TreeItem } from '@mui/x-tree-view';
import React from 'react';
import { FolderTreeNode, TreeLabelBaseProperties } from './types';

export const renderTreeNodes = ({
  nodes,
  level = 0,
  renderLabel,
}: {
  nodes: FolderTreeNode[];
  level: number;
  renderLabel: (properties: TreeLabelBaseProperties) => React.ReactNode;
}) => {
  return nodes
    .filter(node => node.filterDataPointString)
    .map((node, index) => {
      const safeFilterValue = node.filterDataPointString.filter.split(/[^a-zA-Z0-9]/).join('_');
      const itemId = `tree-${level}-${index}-${safeFilterValue}`;
      return (
        <TreeItem
          key={itemId}
          itemId={itemId}
          label={renderLabel({
            itemId,
            label: node.filterLabel,
            _tooltipText: node.filterDataPointString.filter,
            count: node.filterDataPointString.count,
            filterValue: node.filterDataPointString.filter,
          })}
        >
          {node.subFolders.length > 0 && renderTreeNodes({ nodes: node.subFolders, level: level + 1, renderLabel })}
        </TreeItem>
      );
    });
};
